import tools from 'tools';

export default class SmallBasket {
    constructor() {
        this.$el = $('.header-basket-count');
        $(document).on('custom:basketUpdate', this.update.bind(this));
    }

    update(data) {
        const count = Object.entries(data.items).length;

        const vars = {
            count: count,
            countLabel: tools.plural(count, 'товар', 'товара', 'товаров'),
            sum: data.totalSum,
            minOrderSum: data.minOrderSum,
        };

        Object.entries(vars).forEach(([varName, varValue]) => this.$el.find(`[data-var=${varName}]`).html(varValue));
    }
}